function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Alert, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Select, MenuItem, FormControl, InputLabel, Switch } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { constants } from '../constants';
var ApplicationModal = function ApplicationModal(_ref) {
    var _formData$image;
    var open = _ref.open, onClose = _ref.onClose, onSave = _ref.onSave, application = _ref.application, _ref$loading = _ref.loading, loading = _ref$loading === void 0 ? false : _ref$loading, _ref$error = _ref.error, error = _ref$error === void 0 ? null : _ref$error;
    var _useState = useState({
        name: '',
        type: 'single',
        description: '',
        productName: '',
        url: '',
        applicationDescription: '',
        applicationState: true,
        image: null
    }), _useState2 = _slicedToArray(_useState, 2), formData = _useState2[0], setFormData = _useState2[1];
    var _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), imagePreview = _useState4[0], setImagePreview = _useState4[1];
    var isEditMode = !!application;
    // Reset form when modal opens/closes or application changes
    useEffect(function () {
        if (open) {
            if (application) {
                var _application$details, _application$details2, _application$details3, _application$details4, _application$details5;
                setFormData({
                    name: application.name,
                    type: application.type || 'single',
                    description: application.description || '',
                    productName: ((_application$details = application.details) === null || _application$details === void 0 ? void 0 : _application$details.productName) || '',
                    url: ((_application$details2 = application.details) === null || _application$details2 === void 0 ? void 0 : _application$details2.productUrl) || '',
                    applicationDescription: ((_application$details3 = application.details) === null || _application$details3 === void 0 ? void 0 : _application$details3.applicationDescription) || '',
                    applicationState: ((_application$details4 = application.details) === null || _application$details4 === void 0 ? void 0 : _application$details4.applicationState) !== 'inactive',
                    image: null
                });
                if ((_application$details5 = application.details) !== null && _application$details5 !== void 0 && _application$details5.image_base64) {
                    setImagePreview(application.details.image_base64);
                }
                else {
                    setImagePreview(null);
                }
            }
            else {
                setFormData({
                    name: '',
                    type: 'single',
                    description: '',
                    productName: '',
                    url: '',
                    applicationDescription: '',
                    applicationState: true,
                    image: null
                });
                setImagePreview(null);
            }
        }
    }, [open, application]);
    var handleSave = function handleSave() {
        onSave(formData, imagePreview);
    };
    var handleClose = function handleClose() {
        setImagePreview(null);
        onClose();
    };
    var getSubmitButtonText = function getSubmitButtonText() {
        if (loading) {
            return /*#__PURE__*/ React.createElement(CircularProgress, {
                size: 24
            });
        }
        return isEditMode ? constants.configuration_modal_button_update : constants.configuration_modal_button_add;
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: handleClose,
        maxWidth: "sm",
        fullWidth: true
    }, /*#__PURE__*/ React.createElement(DialogTitle, {
        sx: {
            fontSize: '20px',
            fontWeight: 600
        }
    }, isEditMode ? constants.application_modal_title_edit : constants.application_modal_title_add), /*#__PURE__*/ React.createElement(DialogContent, {
        sx: {
            pt: 2
        }
    }, error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 2
        }
    }, error), /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        label: constants.application_modal_field_name,
        value: formData.name,
        onChange: function onChange(e) {
            return setFormData(_objectSpread(_objectSpread({}, formData), {}, {
                name: e.target.value
            }));
        },
        required: true,
        margin: "normal",
        disabled: loading,
        placeholder: constants.application_modal_placeholder_name,
        inputProps: {
            maxLength: 100
        }
    }), /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        label: constants.application_modal_field_description,
        value: formData.description,
        onChange: function onChange(e) {
            return setFormData(_objectSpread(_objectSpread({}, formData), {}, {
                description: e.target.value
            }));
        },
        margin: "normal",
        disabled: loading,
        placeholder: constants.application_modal_placeholder_description,
        inputProps: {
            maxLength: 150
        }
    }), /*#__PURE__*/ React.createElement(FormControl, {
        fullWidth: true,
        margin: "normal",
        required: true
    }, /*#__PURE__*/ React.createElement(InputLabel, null, constants.application_modal_field_type), /*#__PURE__*/ React.createElement(Select, {
        value: formData.type,
        onChange: function onChange(e) {
            return setFormData(_objectSpread(_objectSpread({}, formData), {}, {
                type: e.target.value
            }));
        },
        label: constants.application_modal_field_type,
        disabled: loading
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        value: "single"
    }, constants.application_modal_type_single), /*#__PURE__*/ React.createElement(MenuItem, {
        value: "group"
    }, constants.application_modal_type_group))), /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        label: constants.application_modal_field_product_name,
        value: formData.productName,
        onChange: function onChange(e) {
            return setFormData(_objectSpread(_objectSpread({}, formData), {}, {
                productName: e.target.value
            }));
        },
        required: true,
        margin: "normal",
        disabled: loading,
        placeholder: constants.application_modal_placeholder_product_name,
        inputProps: {
            maxLength: 100
        }
    }), /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        label: constants.application_modal_field_url,
        value: formData.url,
        onChange: function onChange(e) {
            return setFormData(_objectSpread(_objectSpread({}, formData), {}, {
                url: e.target.value
            }));
        },
        required: true,
        margin: "normal",
        disabled: loading,
        placeholder: constants.application_modal_placeholder_url,
        inputProps: {
            maxLength: 500
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mt: 2,
            mb: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        sx: {
            color: '#595959',
            fontSize: '12px',
            lineHeight: '1.28',
            fontWeight: 500
        }
    }, constants.application_modal_field_app_description), /*#__PURE__*/ React.createElement("textarea", {
        value: formData.applicationDescription,
        onChange: function onChange(e) {
            var text = e.target.value.substring(0, 500);
            setFormData(_objectSpread(_objectSpread({}, formData), {}, {
                applicationDescription: text
            }));
        },
        placeholder: constants.application_modal_placeholder_app_description,
        disabled: loading,
        maxLength: 500,
        rows: 4,
        style: {
            width: '100%',
            padding: '12px 12px',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            fontFamily: 'Open Sans, sans-serif',
            fontSize: '16px',
            color: '#212121',
            boxSizing: 'border-box',
            resize: 'vertical',
            fontWeight: 400,
            lineHeight: '1.52',
            transition: 'all 0.3s ease',
            backgroundColor: '#ffffff',
            outline: 'none'
        },
        onFocus: function onFocus(e) {
            e.currentTarget.style.borderColor = '#26890d';
            e.currentTarget.style.boxShadow = '0 0 0 2px rgba(38, 137, 13, 0.2)';
            e.currentTarget.style.outline = 'none';
        },
        onBlur: function onBlur(e) {
            e.currentTarget.style.borderColor = '#d9d9d9';
            e.currentTarget.style.boxShadow = 'none';
        },
        onMouseEnter: function onMouseEnter(e) {
            if (document.activeElement !== e.currentTarget) {
                e.currentTarget.style.borderColor = '#bdbdbd';
            }
        },
        onMouseLeave: function onMouseLeave(e) {
            if (document.activeElement !== e.currentTarget) {
                e.currentTarget.style.borderColor = '#d9d9d9';
            }
        }
    }))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 0.5,
            mb: 2,
            fontSize: '12px',
            color: '#595959'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, constants.application_modal_max_characters), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, formData.applicationDescription.length, "/500")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mt: 2,
            mb: 2
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        sx: {
            color: '#595959',
            fontSize: '12px',
            lineHeight: '1.28',
            fontWeight: 500,
            mb: 1,
            display: 'block'
        }
    }, constants.application_modal_field_app_state), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '14px',
            color: formData.applicationState ? '#949494' : '#212121',
            fontWeight: formData.applicationState ? 400 : 600
        }
    }, constants.application_modal_state_inactive), /*#__PURE__*/ React.createElement(Switch, {
        checked: formData.applicationState,
        onChange: function onChange(e) {
            return setFormData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                    applicationState: e.target.checked
                });
            });
        },
        disabled: loading,
        sx: {
            '& .MuiSwitch-switchBase': {
                color: '#bdbdbd',
                '&.Mui-checked': {
                    color: '#26890d',
                    '& + .MuiSwitch-track': {
                        backgroundColor: '#26890d'
                    }
                }
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '14px',
            color: formData.applicationState ? '#26890d' : '#949494',
            fontWeight: formData.applicationState ? 600 : 400
        }
    }, constants.application_modal_state_active))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mt: 2,
            mb: 2
        }
    }, /*#__PURE__*/ React.createElement("input", {
        accept: "image/*",
        style: {
            display: 'none'
        },
        id: "image-upload",
        type: "file",
        onChange: function onChange(e) {
            var _e$target$files;
            var file = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
            if (file) {
                setFormData(_objectSpread(_objectSpread({}, formData), {}, {
                    image: file
                }));
                // Create preview
                var reader = new FileReader();
                reader.onloadend = function () {
                    setImagePreview(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    }), imagePreview ?
        /*#__PURE__*/
        // Image preview section - matching Figma design
        React.createElement(Box, {
            sx: {
                border: '1px solid #ebebeb',
                borderRadius: '16px',
                p: 2,
                backgroundColor: '#ffffff',
                display: 'flex',
                gap: 2,
                alignItems: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                width: '60px',
                height: '60px',
                borderRadius: '8px',
                overflow: 'hidden',
                flexShrink: 0,
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: imagePreview,
            alt: "Preview",
            style: {
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            }
        }), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                position: 'absolute',
                inset: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.5)'
            }
        })), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                flex: 1
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            sx: {
                fontWeight: 600,
                color: '#212121',
                fontSize: '16px',
                lineHeight: '1.52'
            }
        }, ((_formData$image = formData.image) === null || _formData$image === void 0 ? void 0 : _formData$image.name) || constants.application_modal_image_title_default), /*#__PURE__*/ React.createElement(Typography, {
            variant: "caption",
            sx: {
                color: '#595959',
                fontSize: '12px',
                lineHeight: '1.28'
            }
        }, formData.image ? "".concat((formData.image.size / 1024 / 1024).toFixed(2), "MB/10MB") : '0MB/10MB')), /*#__PURE__*/ React.createElement(Box, {
            component: "label",
            htmlFor: "image-upload",
            sx: {
                display: 'flex',
                gap: 0.5,
                alignItems: 'center',
                cursor: 'pointer',
                p: 1,
                borderRadius: '4px',
                transition: 'background-color 0.2s ease',
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
            }
        }, /*#__PURE__*/ React.createElement(DeleteIcon, {
            sx: {
                fontSize: '24px',
                color: '#212121',
                cursor: 'pointer',
                '&:hover': {
                    color: '#da291c'
                }
            },
            onClick: function onClick(e) {
                e.stopPropagation();
                setFormData(_objectSpread(_objectSpread({}, formData), {}, {
                    image: null
                }));
                setImagePreview(null);
            }
        }))) :
        /*#__PURE__*/
        // Upload placeholder - matching Figma design
        React.createElement("label", {
            htmlFor: "image-upload"
        }, /*#__PURE__*/ React.createElement(Box, {
            component: "div",
            sx: {
                border: '1px solid #ebebeb',
                borderRadius: '16px',
                p: 2,
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: '#ffffff',
                transition: 'all 0.3s ease',
                '&:hover': {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#d9d9d9'
                }
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                gap: 2,
                alignItems: 'center',
                justifyContent: 'flex-start'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                width: '60px',
                height: '60px',
                borderRadius: '8px',
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontSize: '24px',
                color: '#949494'
            }
        }, "\uD83D\uDCC1")), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                flex: 1,
                textAlign: 'left'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                color: '#212121',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '1.52'
            }
        }, constants.application_modal_image_drag_drop), /*#__PURE__*/ React.createElement(Typography, {
            variant: "caption",
            sx: {
                color: '#949494',
                fontSize: '12px',
                lineHeight: '1.28'
            }
        }, constants.application_modal_image_browse))))))), /*#__PURE__*/ React.createElement(DialogActions, null, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleClose,
        disabled: loading,
        sx: {
            color: '#26890d',
            textTransform: 'none'
        }
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleSave,
        variant: "contained",
        disabled: loading,
        sx: {
            backgroundColor: '#26890d',
            textTransform: 'none',
            '&:hover': {
                backgroundColor: '#1f6b0a'
            }
        }
    }, getSubmitButtonText())));
};
export default ApplicationModal;
